import React, { Component } from 'react';
import AuthService from "../services/LoginService";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';


export default class Logout extends Component {

    constructor(props) {
        super(props);

        this.logOut = this.logOut.bind(this);

    }


    componentDidMount() {
        const user = AuthService.getCurrentUser();
        if (user) {
            //console.log("logout ok ")
            //console.log(user)
            this.logOut();
        }else{
            console.log('user not loged');
        }
    }



    logOut() {
        AuthService.logout();
        this.setState({
            showModeratorBoard: false,
            showAdminBoard: false,
            currentUser: undefined,
        });
    }

    render() { 
        return (

            <div className="card card-container">
                
            <Card sx={{ minWidth: 275 }}>
                <CardContent>

                    <Typography variant="h5" component="div">
                        Au revoir sur le portail SIMPHONIE
                    </Typography>
                    <Typography sx={{ mb: 1.5 }} color="text.secondary">
                        @bientôt
                    </Typography>
                    <Typography variant="body2">
                        well meaning and kindly.
                        <br />
                        {'"a benevolent smile"'}
                    </Typography>
                </CardContent>
                <CardActions>
                    <Button size="small" href="/login">Login</Button>
                </CardActions>
            </Card>
 
        </div>
        );
 
     }

}



